export default __webpack_public_path__ + "static/media/proclamation.b5290d2b.png";